import { ReactElement } from 'react'

import { Button as MantineButton } from '@mantine/core'

import Button from 'src/components/Buttons/Button/Button'

export interface ToggleOption {
  value: string
  label: string
  icon?: ReactElement
}

interface ToggleButtonGroupProps {
  options: ToggleOption[]
  value: string
  onChange: (value: string) => void
  className?: string
}

const ToggleButtonGroup = ({
  options,
  value,
  onChange,
  className,
}: ToggleButtonGroupProps) => (
  <MantineButton.Group className={className}>
    {options.map((option) => (
      <Button
        key={option.value}
        text={option.label}
        className="rounded-lg"
        variant={value === option.value ? 'light' : 'outline'}
        onClick={() => onChange(option.value)}
        lefticon={option.icon}
      />
    ))}
  </MantineButton.Group>
)

export default ToggleButtonGroup
